
import * as t from './actionTypes';

export function updateField(value, field) {
  return {
    type: t.UPDATE_FORM_FIELD,
    payload: { field, value },
  };
}
